import { timestampDate } from '@bufbuild/protobuf/wkt'
import { Document, Page } from 'react-pdf'

import { DocumentFact } from '@/gen/inventory/v1/control_service_pb'

import { documentSourceLabel } from '@/const/label'

import { formatTimestamp } from '@/lib/date/date'
import '@/lib/pdf/worker'

import { Badge } from '@/components/lemmala-design-system/badge/badge'
import { Hyperlink } from '@/components/lemmala-design-system/link/hyperlink'
import { Skeleton } from '@/components/lemmala-design-system/skeleton/skeleton'
import { ArtifactExpirationDate } from '@/components/shared/artifact-expiration-date/artifact-expiration-date'
import { ErrorBoundary } from '@/components/shared/error-boundary/error-boundary'

type DocumentFactFilePreviewProps = {
  documentFact: DocumentFact
}

export const DocumentFactFilePreview = ({
  documentFact: { link, subcategory, name, expirationDate, source, uploadedAt },
}: DocumentFactFilePreviewProps) => {
  return (
    <div className='flex gap-x-7 rounded border border-main-border-default p-3 shadow'>
      <ErrorBoundary key={link} fallback={<Skeleton className='h-52 w-40' />}>
        <Document
          className='shrink-0 border border-main-border-default'
          file={link}
          loading={<Skeleton className='h-52 w-40' />}
          error={<Skeleton className='h-52 w-40' />}
        >
          <Page
            loading={<Skeleton className='h-52 w-40' />}
            height={166}
            pageNumber={1}
            scale={1.25}
            renderAnnotationLayer={false}
          />
        </Document>
      </ErrorBoundary>
      <div className='flex min-w-0 flex-1 flex-col gap-3'>
        {subcategory && (
          <Badge variant='secondary' className='w-fit rounded'>
            {subcategory}
          </Badge>
        )}
        <Hyperlink className='truncate' href={link}>
          {name}
        </Hyperlink>
        {expirationDate && (
          <ArtifactExpirationDate expirationDate={timestampDate(expirationDate)} />
        )}
        <div className='flex gap-2'>
          <p>{documentSourceLabel[source]}</p>
          {uploadedAt && <p>{formatTimestamp(uploadedAt)}</p>}
        </div>
      </div>
    </div>
  )
}

export const PdfLoading = () => {
  return (
    <div className={'ml-8 flex flex-col gap-2 px-6'}>
      {[...Array(20)].map((_, index) => (
        <Skeleton className='h-4 w-full min-w-28' key={index} />
      ))}
    </div>
  )
}
